"use strict";

(function () {
  var timezoneList = document.querySelectorAll('.time_zone_list__item');
  var modalClose = function modalClose(target) {
    var close = target.querySelector('[data-modal-close]');
    close.click();
  };
  if (timezoneList) {
    timezoneList.forEach(function (item) {
      item.addEventListener('click', function () {
        if (!item.dataset.value && !item.dataset["for"]) return;
        var timezone = item.dataset.value;
        var target = item.dataset["for"];
        var timezoneLabel = document.getElementById(target);
        if (timezoneLabel) {
          timezoneLabel.innerHTML = timezone;
          item.closest('.modal') && modalClose(item.closest('.modal'));
        }
      }, false);
    });
  }
})();